module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='By Brand\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/subfilters/vendor-select-selected/vendor-select.html
 ** module id = 662
 ** module chunks = 1 7 43 115
 **/